import { render, staticRenderFns } from "./ItemPurchaseReport.vue?vue&type=template&id=230fb467&"
import script from "./ItemPurchaseReport.vue?vue&type=script&lang=js&"
export * from "./ItemPurchaseReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ItemPurchaseReport.vue"
export default component.exports